export default "__VITE_ASSET__D$KTYkoO__"